export default "__VITE_ASSET__DMF79jie__"